module.exports = "<button \r\n  *claims=\"{ resource:'Program',operation:'Notify'}\"\r\n  class=\"btn btn-lg\" (click)=\"notify()\">\r\n  Notify\r\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/notify-button/notify-button.component.html
// module id = ./src/app/shared/components/notify-button/notify-button.component.html
// module chunks = main